function formatDate(date) {
  return date.split("T")[0];
}

function formatDateForChart(date) {
  return new Date(date?.toString()).toISOString().split(".000Z")[0];
}

export { formatDate, formatDateForChart };
